// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/printer.js';

import { paths } from '../generated/printer';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('printer', Original, paths);
